import React from "react";

import { components } from "react-select";

import type { ClearIndicatorProps } from "react-select";

import { DenovoIcon } from "../../icons";
import { IOption } from "../interfaces";

export const ClearIndicator: React.FC<ClearIndicatorProps<IOption>> = (
  props,
) => {
  return (
    <components.ClearIndicator {...props}>
      <DenovoIcon icon="clear" color="text-contentPrimary" />
    </components.ClearIndicator>
  );
};
